export const DataRouteParamModuleIndex = 'moduleIndex';
